import { Injectable } from '@angular/core';
import {
	CanActivate,
	Router,
	ActivatedRouteSnapshot,
	RouterStateSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, take, switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { RcService } from '../services/rc.service';

@Injectable({
	providedIn: 'root'
})
export class InventoryAccessGuard implements CanActivate {
	constructor(
		private readonly router: Router,
		private readonly rcService: RcService,
		private readonly authService: AuthService
	) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean> {
		return this.authService.currentUser$.pipe(
			take(1),
			switchMap((userData) => {
				const employeeNumber = userData?.credentials?.EmployeeNumber;
				const isUserPresent = userData?.ApplicationUserName;

				if (!employeeNumber) {
					this.router.navigate([`/${this.rcService.getTenant()}`]);
					return of(false);
				}

				return this.authService
					.checkInventoryAccess(employeeNumber)
					.pipe(
						map((response: any) => {
							if (response.IsInventoryAccess && isUserPresent) {
								return true;
							} else {
								// Redirect to an appropriate URL, e.g., /no-access
								this.router.navigate([
									`/${this.rcService.getTenant()}`
								]);
								return false;
							}
						}),
						catchError(() => {
							this.router.navigate([
								`/${this.rcService.getTenant()}`
							]);
							return of(false);
						})
					);
			})
		);
	}
}
